module.exports = __webpack_public_path__ + "img/quotes-success.8a0d2d9f.svg";